import * as yup from "yup";

export const createClientAccPDValidation = () => {
  const schema = yup.object().shape({
    client_account: yup.object().label('This field').required().typeError("This field is a required"),
    pdList: yup.string().required("This table should not be empty"),
  });

  return { schema };
};
